import { formSchema } from "../../validaciones/validacionNotificaciones";
import { apiFetch } from "../../utils/api";

const crearPayload = (datos) => ({
    titulo: datos.titulo,
    subtitulo: datos.subtitulo || null,
    descripcion: datos.tiene_contenido_detallado ? datos.descripcion || null : datos.subtitulo || null,
    imageUrl: datos.imagen || null,
    imageKey: datos.imageKey || null,
    tipo: datos.tipo || "sencilla",
    tipoId: datos.tipo === "sencilla" ? null : datos.tipoId || null,
    tipoProgramacion: datos.tipoProgramacion || "inmediato",
    destinatarios: "todos",
});

export const notificacionesSlice = (set,get) => ({
    insertarNotificacion: async () => {
        const result = formSchema.safeParse({ ...get().datos });
        if (!result.success) {
            console.log(result.error.errors);
            console.log(result.error.flatten().fieldErrors);
            set({error:result.error.flatten().fieldErrors})
            return;
        }
        set({error:null})

        try {
            const data = await apiFetch("/api/push-notifications",{
                method: "POST",
                body: JSON.stringify(crearPayload(get().datos))
            });
            console.log('El dato',data);
            if(data.status){
                get().elNavigate(-1);
                get().limpiar();
            } else {
                set({ error: { general: [data.message || "No se pudo guardar la notificación."] } });
            }
        } catch (error) {
            console.log('Error',error);
            set({ error: { general: [error.message || "No se pudo guardar la notificación."] } });
        }
    },
    
    subirImagen: async (file) => {
        set({ uploadingImage: true });
        try {
            const formData = new FormData();
            formData.append('imagen', file);
            const data = await apiFetch("/api/push-notifications/upload-image", {
                method: "POST",
                body: formData
            });

            if (data.status && data.data?.url) {
                set({ 
                    datos: { ...get().datos, imagen: data.data.url, imageKey: data.data.key || "" },
                    uploadingImage: false 
                });
                return data.data.url;
            } else {
                throw new Error(data.message || 'Error al subir imagen');
            }
        } catch (error) {
            console.error('Error subiendo imagen:', error);
            set({ uploadingImage: false });
            throw error;
        }
    },
    obtenerOpcionesNotificacion: async() => {
        try {
            const data = await apiFetch("/api/push-notifications/options");
            console.log('Opciones notificacion',data);
            if(data.status){
                const tiposNotificacion = data.data.tipos.map((item) => { 
                    return { value: String(item.id), label: item.nombre } 
                });
                set({ 
                    tipos_notificacion: tiposNotificacion,
                    sucursales: data.data.sucursales.map((item) => { return { value: String(item.id), label: item.nombre } }),
                    preferencias: data.data.preferencias.map((item) => { return { value: String(item.id), label: item.nombre } }),
                    dispositivos: data.data.dispositivos.map((item) => { return { value: String(item.id), label: item.platform || item.token } }),
                    partidas: (data.data.partidas || []).map((item) => {
                        const fecha = item.fecha ? new Date(item.fecha).toLocaleString("es-MX") : "Sin fecha";
                        const cancha = item.cancha?.nombre ? ` · ${item.cancha.nombre}` : "";
                        const sucursal = item.sucursal?.nombre ? ` · ${item.sucursal.nombre}` : "";
                        return { value: String(item.id), label: `${item.titulo || "Partida"} · ${fecha}${cancha}${sucursal}` };
                    }),
                    productos: (data.data.productos || []).map((item) => {
                        const precio = item.precio !== undefined && item.precio !== null ? ` · $${Number(item.precio).toFixed(2)}` : "";
                        return { value: String(item.id), label: `${item.nombre}${precio}` };
                    }),
                    datos: {
                        ...get().datos,
                        tipo: get().datos.tipo || (tiposNotificacion.length > 0 ? tiposNotificacion[0].value : "sencilla")
                    }
                })
            }
        } catch (error) {
            console.error('Error opciones notificacion:', error);
            set({ tipos_notificacion: [{ value: "sencilla", label: "Informativa" }] });
        }
    }
})
